module.exports = __webpack_public_path__ + "static/media/snooker.b3dfc8b0.svg";